// Buy-X-get-Y-free / spend-X-get-Y-free automation. A promotion hangs off the
// product, in the custom.cart_gift_rule metafield, which points at a
// cart_gift_rule metaobject. snippets/cart-gift-rules-data.liquid collects the
// promotions that can apply on this page into #cart-gift-rules-data. A rule
// fires once the variant reaches triggerQuantity units OR the cart reaches
// triggerPriceCents in subtotal (either is enough; a trigger left at 0 is
// off).
//
// It only ever tops the cart up, and only right after the customer added
// something. Reacting to every cart change would fight the quantity
// stepper: the customer clicks minus once, drops under the trigger, and
// the rule would pull the free units back out under their hands.
//
// Two shapes, depending on whether the gift is the product being bought:
//   - Variant already in the cart: its quantity is topped up to
//     triggerQuantity + giftQuantity, so "buy 3, get 2 free" -> 5. The
//     automatic Buy X get Y discount turns that into 3 paid and 2 free units,
//     shown as a single cart line (see snippets/drawer-item.liquid).
//   - Variant not in the cart yet: giftQuantity units are added, the "spend 50
//     euros and product Y is free" case.
// Subscription lines stay out of it, Buy X get Y doesn't apply to them.
(function () {
  // Only these sources mean "the customer added something". 'cart-items' is
  // the quantity stepper in the cart and is deliberately left out.
  const ADD_SOURCES = ['product-form', 'upsell-products', 'quick-add'];

  const dataEl = document.getElementById('cart-gift-rules-data');
  if (!dataEl) return;

  let rules;
  try {
    rules = JSON.parse(dataEl.textContent);
  } catch (error) {
    return;
  }
  if (!Array.isArray(rules) || rules.length === 0) return;

  let running = false;
  let changed = false;

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => response.json());
  }

  function fetchCart() {
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then((response) =>
      response.json()
    );
  }

  // The lines of one variant that the customer sees as a single position: no
  // properties of their own, no subscription. A Buy X get Y discount splits
  // them into a paid and a free part, but they are still one quantity.
  function variantLines(cart, variantId) {
    return cart.items.filter(
      (item) =>
        item.variant_id === variantId &&
        !item.selling_plan_allocation &&
        (!item.properties || Object.keys(item.properties).length === 0)
    );
  }

  function quantityInCart(cart, variantId) {
    return variantLines(cart, variantId).reduce((sum, line) => sum + line.quantity, 0);
  }

  function topUp(cart) {
    return rules.reduce((chain, rule) => {
      const priceMet = rule.triggerPriceCents > 0 && cart.items_subtotal_price >= rule.triggerPriceCents;

      // The quantity threshold counts the product the promotion hangs off,
      // not the whole cart: "buy three" means three of this one. When a
      // product gifts itself, trigger and gift are the same variant.
      const triggerTotal = rule.triggerVariantIds.reduce(
        (sum, variantId) => sum + quantityInCart(cart, variantId),
        0
      );
      const quantityMet = rule.triggerQuantity > 0 && triggerTotal >= rule.triggerQuantity;
      if (!quantityMet && !priceMet) return chain;

      return rule.variantIds.reduce((variantChain, variantId) => {
        const lines = variantLines(cart, variantId);
        const total = lines.reduce((sum, line) => sum + line.quantity, 0);

        if (total === 0) {
          changed = true;
          return variantChain.then(() =>
            postJSON(window.routes.cart_add_url, { id: variantId, quantity: rule.giftQuantity })
          );
        }

        // When the product gifts itself, the target is the full promotion,
        // so three paid plus two free. When the gift is a different product,
        // the free units are all it takes.
        const selfGift = rule.triggerVariantIds.indexOf(variantId) !== -1;
        const target = selfGift && rule.triggerQuantity > 0 ? rule.triggerQuantity + rule.giftQuantity : rule.giftQuantity;
        if (total >= target) return variantChain;

        // The top-up goes onto the first line. How that quantity then splits
        // into paid and free is Shopify's own arithmetic.
        const line = lines[0];
        changed = true;
        return variantChain.then(() =>
          postJSON(window.routes.cart_change_url, { id: line.key, quantity: line.quantity + target - total })
        );
      }, chain);
    }, Promise.resolve());
  }

  function run() {
    if (running) return;
    running = true;
    changed = false;

    fetchCart()
      .then((cart) => topUp(cart))
      .then(() => {
        if (changed) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-gift-rules' });
      })
      .catch(() => {})
      .finally(() => {
        running = false;
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event && ADD_SOURCES.indexOf(event.source) !== -1) run();
  });
})();
